

import assest from "../../../Assets/Img/case1.webp"
import barcode from "../../../Assets/Img/case2.webp"
import tracking from "../../../Assets/Img/case3.webp"
import realtime from "../../../Assets/Img/case4.webp"
import batch from "../../../Assets/Img/case5.webp"
import inventorymobile from "../../../Assets/Img/case6.webp"
import case1icon from "../../../Assets/Img/case1icon.webp"
import case2icon from "../../../Assets/Img/case2icon.webp"
import case3icon from "../../../Assets/Img/case3icon.webp"
import case4icon from "../../../Assets/Img/case4icon.webp"
import case5icon from "../../../Assets/Img/case5icon.webp"
import case6icon from "../../../Assets/Img/case6icon.webp"


const Data=[
    {
        Img:assest,
        Iconimage:case1icon,
        heading:"Case 1",
        text:"Integrated Weight, Print & Mobile Tracking System"
    },
    {
        Img:barcode,
        Iconimage:case2icon,
        heading:"Case 2",
        text:"Custom-Built CRM for New Product Development, Processing & Controls"
    },
    {
        Img:tracking,
        Iconimage:case3icon,
        heading:"Case 3",
        text:"End-to-End Tracking: Challenges from the Factories"
    },
    {
        Img:realtime,
        Iconimage:case4icon,
        heading:"Case 4",
        text:"Multi Regional Multi Currency Integrated Display"
    },
    {
        Img:batch, 
        Iconimage:case5icon,   
        heading:"Case 5",
        text:"Production Scheduling Optimisation (System) Modelling"
    },
    {
        Img:inventorymobile,
        Iconimage:case6icon,
        heading:"Case 6",
        text:"Optimizing the Cutting Sequence To Reduce Wastage"
    }
  
]
export default Data;